import React, { useState } from 'react'
import './auth.scss'
import Logo from '../../assets/images/logo.png'
import { Link, useNavigate } from 'react-router-dom'
import { postNo } from '../../utilities/API/api'
import Loader from '../../components/loader/Loader'

function ForgetPassword({ notify }) {
  const [emailAddress, setEmailAddress] = useState('')
  const [formLoading, setFormLoading] = useState(false)
  const navigate = useNavigate()
  function submit() {
    if (emailAddress.length < 1) {
      notify('error', 'Email address is compulsory')
    } else {
      setFormLoading(true)
      postNo('users/otp/request', {
        email: emailAddress,
      })
        .then((data) => {
          if (Object.keys(data).includes('error')) {
            notify('error', data.error)
            setFormLoading(false)
          } else {
            notify('success', 'OTP sent')
            setTimeout(() => {
              navigate(`/reset-password/${emailAddress}`)
            }, 2000)
            setFormLoading(false)
          }
        })
        .catch(() => {
          setFormLoading(false)
        })
    }
  }
  return (
    <div className='flex justify-center auth'>
      <div className='modal'>
        <div className='modal-wrap'>
          <div className='top'>
            <img src={Logo} alt='' onClick={() => navigate('/')} />
          </div>
          <div className='form'>
            <div className='form-cover'>
              <div className='form-card'>
                <p>Email Address</p>
                <input
                  type='email'
                  name=''
                  id=''
                  onChange={(e) => setEmailAddress(e.target.value)}
                />
              </div>
              {formLoading ? (
                <Loader location='center' />
              ) : (
                <div className='form-card'>
                  <button onClick={submit} className='submit'>
                    Reset
                  </button>
                </div>
              )}
              <div className='flex justify-between'>
                <Link to={'/sign-up'}>
                  <p>Sign Up</p>
                </Link>
                <Link to={'/login'}>
                  <p>Login</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgetPassword
